import styled from 'styled-components';
import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';

export const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 32px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    flex-direction: column-reverse;
    gap: 0;
  }
`;

export const FAQsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
